export const SOCKET_BASEURL = () => {
    const instanceRes = JSON.parse(localStorage.getItem('instance'));

    if (!instanceRes || !instanceRes.SocketBaseUrl) {
        console.error("SocketBaseUrl not found in local storage");
        return null;
    }
    
    return instanceRes.SocketBaseUrl;
};
